import { render } from "./UnderRecruitment.vue?vue&type=template&id=743ca985&scoped=true"
import script from "./UnderRecruitment.vue?vue&type=script&lang=js"
export * from "./UnderRecruitment.vue?vue&type=script&lang=js"

import "./UnderRecruitment.vue?vue&type=style&index=0&id=743ca985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743ca985"]])

export default __exports__